import React, { useEffect, useRef } from 'react';
import { EXPRESS_URL } from 'new/constants/pathnames';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import styles from './ExpressView.module.scss';

const EXPRESS_ORIGIN = process.env.REACT_APP_EXPRESS_ORIGIN || EXPRESS_URL;
const IFRAME_SRC = `${EXPRESS_ORIGIN}?embedded=true`;

export default function ExpressView() {
  const currentUser = useCurrentUser();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const iframeReadyRef = useRef<boolean>(false);
  const prevCurrentUserRef = useRef(currentUser);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== EXPRESS_ORIGIN) return;

      if (event.data?.type === 'VEDA_IFRAME_READY') {
        iframeReadyRef.current = true;
        if (currentUser?.token) {
          iframeRef.current?.contentWindow?.postMessage(
            { type: 'NEXLA_AUTH_TOKEN', token: currentUser.token, user: currentUser },
            EXPRESS_ORIGIN,
          );
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [currentUser]);

  // Send credentials when currentUser transitions from null to a valid value
  useEffect(() => {
    const prevUser = prevCurrentUserRef.current;
    prevCurrentUserRef.current = currentUser;

    // Only send credentials when:
    // 1. The iframe is ready
    // 2. currentUser is truthy and has a token
    // 3. currentUser transitioned from null/undefined to a valid value
    if (iframeReadyRef.current && currentUser?.token && !prevUser?.token) {
      iframeRef.current?.contentWindow?.postMessage(
        { type: 'NEXLA_AUTH_TOKEN', token: currentUser.token, user: currentUser },
        EXPRESS_ORIGIN,
      );
    }
  }, [currentUser]);

  return (
    <div className={styles.expressContainer}>
      <iframe
        ref={iframeRef}
        src={IFRAME_SRC}
        title="Nexla Express"
        style={{ width: '100%', height: '100%', border: 'none' }}
        allow="clipboard-write"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
    </div>
  );
}
